import { Button, Flex, Text, useMantineTheme } from "@mantine/core";
import {
  Modal,
  PasswordInputControlled,
  PasswordRequirements,
} from "../../../components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationRecovery } from "../../../utils/validation/schemas/validationChangePassword";
import { useState } from "react";
import { IFormChangePassword } from "../../../interfaces/User/newUser";
import { useNotificationControl } from "../../../context/notificationContext";
import { useMutation } from "@tanstack/react-query";
import { postChangePassword } from "../../../hooks/useUsers";
import { useAuth } from "../../../context/auth";
import LayoutFormAuth from "../_components/LayoutFormAuth";
import { useTranslation } from "react-i18next";

interface IProps {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}
const TempPassword = ({ setIsLoading, isLoading }: IProps) => {
  const theme = useMantineTheme();
  const { logout } = useAuth();
  const { notificationControl } = useNotificationControl();
  const { t } = useTranslation();
  const methods = useForm<IFormChangePassword>({
    mode: "onChange",
    resolver: yupResolver(ValidationRecovery),
    defaultValues: {
      old_password: "",
      new_password: "",
      second_new_password: "",
    },
  });

  const {
    handleSubmit,
    watch,
    formState: { isDirty, isValid },
  } = methods;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const { mutate: changePassword } = useMutation(postChangePassword, {
    onSuccess: () => {
      setOpenModal(!openModal);
      setIsLoading(false);
    },
    onError: (errors: any) => {
      if (errors?.response?.status === 401) {
        notificationControl({
          message: t(
            "autenticacao.mudar_senha_temporaria.notification.message_error_401"
          ),
          type: "danger",
        });
      } else {
        notificationControl({
          type: "danger",
        });
      }

      setIsLoading(false);
    },
  });

  const onSubmit = (data: IFormChangePassword) => {
    setIsLoading(true);
    changePassword(data);
  };

  return (
    <LayoutFormAuth<IFormChangePassword> methods={methods}>
      <Modal
        type="success"
        titleSeccondButton={t("global.modal.close")}
        description={t(
          "autenticacao.mudar_senha_temporaria.modal_success.description"
        )}
        open={openModal}
        setClose={logout}
        firstClick={() => {}}
        secondClick={logout}
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          display: "flex",
          gap: "24px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Text
          fw={{ base: 600 }}
          fz={{ base: 24 }}
          lh={{ base: "37.2px" }}
          color={theme.colors.basic[5]}
        >
          {t("autenticacao.mudar_senha_temporaria.title")}
        </Text>
        <PasswordInputControlled
          name="old_password"
          label={t("global.input.old_password.label")}
          placeholder={t("global.input.old_password.placeholder")}
          withAsterisk
        />

        <Flex gap={{ base: 24 }} direction={{ base: "column", 1700: "row" }}>
          <PasswordInputControlled
            name="new_password"
            label={t("global.input.new_password.label")}
            placeholder={t("global.input.new_password.placeholder")}
            withAsterisk
            w="100%"
          />

          <PasswordInputControlled
            name="second_new_password"
            label={t("global.input.second_new_password.label")}
            placeholder={t("global.input.second_new_password.placeholder")}
            withAsterisk
            w="100%"
          />
        </Flex>
        <PasswordRequirements
          passwordOne={watch("new_password")}
          passwordTwo={watch("second_new_password")}
        />
        <Button
          variant="primary"
          type="submit"
          disabled={!isDirty || !isValid}
          loading={isLoading}
        >
          {t("autenticacao.mudar_senha_temporaria.title")}
        </Button>
      </form>
    </LayoutFormAuth>
  );
};

export default TempPassword;
